import { ApiService } from "./api.service";
export default class QuickNoteService extends ApiService {
  namespace = "Notepad";
  template = "QuickNoteTemplate";
  DOMAIN = 25;
  icon = "Notepad";
  name = "Notepad";
  constructor() {
    super("notepads");
  }
}
